import React, { memo, forwardRef } from "react";
const SvgZeta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.987 27.632c-.694 0-1.144-.744-.897-1.393l.062-.167c.208-.528.312-.968.312-1.32 0-.304-.048-.56-.144-.768-.08-.192-.272-.368-.576-.528-.288-.144-.736-.28-1.344-.408-1.376-.304-2.456-.672-3.24-1.104-.784-.448-1.344-.976-1.68-1.584-.32-.624-.48-1.344-.48-2.16 0-.912.192-1.816.576-2.712.4-.896.952-1.832 1.656-2.808.704-.992 1.504-2.072 2.4-3.24l2.616-3.384c-.064 0-.288.008-.672.024-.368.016-.824.032-1.368.048-.528.016-1.064.024-1.608.024h-2.076a.804.804 0 010-1.608h7.171a.953.953 0 01.761 1.527l-3.408 4.521a93.56 93.56 0 00-2.256 3.144c-.56.848-.968 1.6-1.224 2.256a5.136 5.136 0 00-.384 1.92c0 .544.096 1.016.288 1.416.192.4.568.752 1.128 1.056.576.304 1.44.592 2.592.864.832.192 1.496.408 1.992.648.496.24.848.536 1.056.888.224.352.336.808.336 1.368 0 .464-.048.896-.144 1.296-.096.416-.224.8-.384 1.152-.082.18-.166.359-.252.535a.896.896 0 01-.809.497z"
      />
    </svg>
  );
});
SvgZeta.displayName = "SvgZeta";
const MemoForwardRef = memo(SvgZeta);
export default MemoForwardRef;
